const Spinner = () => {
  return (
    <div className='w-full h-full ' style={{border: '1px dashed white'}}>
      <div className="spinner bg-bgColor text-primaryColor">Cargando...</div>
    </div>
  )
}

export default Spinner
